var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-navbar",
    { attrs: { fixed: "top", variant: "white" } },
    [
      _c(
        "b-navbar-brand",
        {
          staticClass: "app-sidebar-brand text-center py-0",
          attrs: { to: "/" }
        },
        [
          _c("span", [
            _c("img", {
              staticClass: "dark-logo",
              attrs: {
                src: require("@/assets/logo.png"),
                alt: "logo-text",
                height: "40"
              }
            })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "b-navbar-nav",
        { staticClass: "ml-auto px-4" },
        [
          _vm.isSignedIn
            ? _c(
                "b-nav-item",
                { attrs: { href: "#" }, on: { click: _vm.signOut } },
                [
                  _c("span", { staticClass: "ti-power-off" }),
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("message.appHeader.btn.signOut")) +
                      "\n    "
                  )
                ]
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fc5ca04c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc5ca04c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/AppHeader.vue
// module id = n5ys
// module chunks = 1